import React from 'react';
import * as Eventos from '../../constantes/EventosEquiposTorneos.js';

const CampoOptionsTitulo = (props) => {
  const estilo = props.estilo;
  const editar = props.editar;
  const nombre = props.nombre;
  const valor = props.valor;

  const onChangeHandler = (event) => {
    const newValue = event.target.value === valor ? null : event.target.value;
    props.onChange(nombre, newValue);
  };

  let campo = '';
  if (editar) {
    campo = (
      <div className={`${estilo}`}>
        <label>
          <input
            type="radio"
            name="tituloObtenido"
            value={Eventos.CAMPEON}
            checked={valor === Eventos.CAMPEON}
            onChange={onChangeHandler}
          />{' '}
          Campeón
        </label>
        {'  '}
        <label>
          <input
            type="radio"
            name="tituloObtenido"
            value={Eventos.SUBCAMPEON}
            checked={valor === Eventos.SUBCAMPEON}
            onChange={onChangeHandler}
          />{' '}
          Subcampeón
        </label>
      </div>
    );
  } else {
    switch (valor) {
      case Eventos.CAMPEON: {
        campo = 'Campeón';
        break;
      }
      case Eventos.SUBCAMPEON: {
        campo = 'Subcampeón';
        break;
      }
      default: {
        campo = '';
      }
    }
  }
  return campo;
};

export default CampoOptionsTitulo;
